/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery(document).ready(function(){
  if($('.ProductList--carousel.owl-carousel').length > 0) {
    $('.ProductList--carousel.owl-carousel').owlCarousel({
      loop:false,
      margin:0,
      nav:false,
      dots:true,
      dotsEach:true,
      responsiveClass:true,
      items:4,
      responsive:{
        0:{
          items:1,
          slideBy: 1
        },
        768:{
          items:2,
          slideBy: 2
        },
        991:{
          items:3,
          slideBy: 3
        },
        1199:{
          items:4,
          slideBy: 4
        }
      }
    })
  }

  if($('.swiper-container').length > 0) {
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      //       scrollbar: {
      //         el: '.swiper-scrollbar',
      //         hide: false,
      //       },
    })

    //     mySwiper.on('onProgress', this._carouselTranslateScrollbar.bind(this));
    //     mySwiper.on('onSetTransition', this._carouselSetTransitions.bind(this));
    swiper.on('reachEnd', function(){
      $(".swiper-container").addClass('tets');
    });
    swiper.on('reachBeginning', function(){
      $(".swiper-container").removeClass('tets');
    });
  }

  if($('.ArticleList-slider').length > 0){
    $('.ArticleList-slider').owlCarousel({
      loop:false,
      margin:0,
      nav:true,
      responsiveClass:true,
      responsive: {
        0: {
          items:1
        },
        767: {
          items:1
        },
        1000: {
          items:1
        }
      }
    })
  }

  setTimeout(function() {
    if($(".NewsletterPopup").attr("aria-hidden")=="false") {
      $("body").addClass("newsletter-background");
      $(".NewsletterPopup__Close").click(function() {
        $(".template-index").removeClass("newsletter-background")
      })
    }
  },1000)

  $('.Footer .Footer__Block .Footer__Title').click(function() {
    $(this).next('.Linklist').slideToggle();
    $(this).toggleClass('active');
  })

  if($(this).scrollTop() <= 30) {
    $(".SidebarMenu__Nav--secondary").css("margin-bottom", "35px")
  } else {
    $(".SidebarMenu__Nav--secondary").css("margin-bottom", "0px")
  }

  $(window).scroll(function(){
    if($(this).scrollTop() <= 30) {
      $(".SidebarMenu__Nav--secondary").css("margin-bottom", "35px")
    } else {
      $(".SidebarMenu__Nav--secondary").css("margin-bottom", "0px")
    }
  })

  if($("body").width() > 640) {
    if ($(this).scrollTop() > 30) {
      $(".PageOverlay").css("top","67px");
      $("section#sidebar-menu").css("top","67px");
    }
    $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
        $(".PageOverlay").css("top","67px");
        $("#sidebar-menu").css("top","67px");
      } else {
        $(".PageOverlay").css("top","110px");
        $("#sidebar-menu").css("top","110px");
      }
    })
  } else {
    if($(this).scrollTop() > 30) {
      $(".PageOverlay").css("top","61px");
      $("section#sidebar-menu").css("top","61px");
    } else {
      $(".PageOverlay").css("top","104px");
      $("#sidebar-menu").css("top","104px");
    }

    $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
        $(".PageOverlay").css("top","61px");
        $("#sidebar-menu").css("top","61px");
      } else {
        $(".PageOverlay").css("top","104px");
        $("#sidebar-menu").css("top","104px");
      }
    })
  }

  $(window).resize(function(){
    if($("body").width() > 640) {
      if($(this).scrollTop() > 30) {
        $(".PageOverlay").css("top","67px");
        $("section#sidebar-menu").css("top","67px");
      }

      $(window).scroll(function(){
        if($(this).scrollTop() > 30) {
          $(".PageOverlay").css("top","67px");
          $("#sidebar-menu").css("top","67px");
        } else {
          $(".PageOverlay").css("top","110px");
          $("#sidebar-menu").css("top","110px");
        }
      })
    } else {
      $(window).scroll(function(){
        if($(this).scrollTop() > 30) {
          $(".PageOverlay").css("top","61px");
          $("#sidebar-menu").css("top","61px");
        } else {
          $(".PageOverlay").css("top","104px");
          $("#sidebar-menu").css("top","104px");
        }
      })
    }
  })

  // $(document).mouseup(function(e){
  //   console.log('html click');
  //   var containerMenu = jQuery("button.Header__Icon.Icon-Wrapper");
  //   if (!containerMenu.is(e.target) && containerMenu.has(e.target).length == 0) 
  //   { 
      
  //       console.log('html containerMenu');
  //       $("#sidebar-menu").attr("aria-hidden","true");
  //       $("#sidebar-menu").removeAttr("tabindex");
  //       $(".PageOverlay").removeClass("is-visible");
  //       $("html").removeClass("no-scroll");
        
  //   }
  // });
  
  $("button.Header__Icon.Icon-Wrapper").click(function() {
    if($("#sidebar-menu").attr("aria-hidden")=="false"){      
      $("#sidebar-menu").attr("aria-hidden","true");
      $("#sidebar-menu").removeAttr("tabindex");
      $(".PageOverlay").removeClass("is-visible");
      $("html").removeClass("no-scroll");
    } else {      
      $('#shopify-section-header #Search .Search__Inner .Search__SearchBar .Search__Close').trigger('click');
      $("#sidebar-menu").attr("aria-hidden","false");
      $("#sidebar-menu").attr("tabindex","-1");
      $(".PageOverlay").addClass("is-visible");
      $("html").addClass("no-scroll");
    }
  });  

  $('.SidebarMenu .SidebarMenu__Nav--secondary .Linklist__Item a[data-action="toggle-search"]').click(function(){
    if($("#sidebar-menu").attr("aria-hidden")=="false"){
      $("#sidebar-menu").attr("aria-hidden","true");
      $("#sidebar-menu").removeAttr("tabindex"); 
    }
    // $("#sidebar-menu").attr("aria-hidden","true");
    // $("#sidebar-menu").removeAttr("tabindex");    
    // $('section#sidebar-menu header.Drawer__Header button.Drawer__Close').click();
  })

  $(window).scroll(function(){
    var sticky = $('body'),
        scroll = $(window).scrollTop();

    if (scroll >= $('#section-announcement').outerHeight()) sticky.addClass('header-fixed');
    else sticky.removeClass('header-fixed');
  });

  //Match height FUNCTION CALL
  function MatchHeight() {
    jQuery('section.blog-list-item .info .title-item').matchHeight();
    jQuery('section.blog-list-item .info .content-item').matchHeight();
    jQuery('section.blog-list-item .info .link-item').matchHeight();
    jQuery('.template-index .CollectionItem__Content .SectionHeader__SubHeading').matchHeight();
    jQuery('.template-index .CollectionItem__Content h2').matchHeight();
  }
  //Functions that run when all HTML is loaded
  jQuery(document).ready(function() {
    MatchHeight();
  });

  $('.Slideshow .owl-dot').on('event', function() {
    $(this).addClass('active').trigger('classChange');
  });

  $('.Slideshow .owl-dot').bind('DOMSubtreeModified',function(){
    var color = $(this).attr('data-color');
    $('.Slideshow .owl-dot').each(function() {
      $(this).css('color',color);
    })
  })

  if($(".ColletionContainer-Wrapper").length > 0) {
    const slider = document.querySelector(".ColletionContainer-Wrapper");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
                            isDown = false;
                            slider.classList.remove("active");
  });

  slider.addEventListener("mouseup", () => {
                          isDown = false;
                          slider.classList.remove("active");
});
slider.addEventListener("mousemove", (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});
}
  if($('.blog-list-item')){
  $('.blog-list-item .page-width').addClass('swiper-wrapper');
  $('.blog-list-item .page-width  .item').addClass('swiper-slide');
  $('.blog-list-item').addClass('swiper-blog');
  var swiper = new Swiper(".swiper-blog", {
    breakpoints: {
      0: {
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: -3,
      },
      768: {
        slidesPerView: 3,
        allowTouchMove: false,
        spaceBetween: 0,
      },
      1440:{
        slidesPerView: 3,
        allowTouchMove: false,
        spaceBetween: 0,
      }
    }
  });
  var os = navigator.platform;
  var isIphone = os.includes('iPhone');
  if(isIphone){
	$('body').addClass(os);
    $('.template-index.iPhone .Slideshow.Slideshow--fullscreen').height($(window).height()-$('#section-announcement').height()-$('.Header__Wrapper').height())
  }
}

// setTimeout(function() { 
//   $('.AnnouncementBar .AnnouncementBar__Wrapper').marquee({
//     pauseOnHover: 'true',
//     duration: 15000,
//     delayBeforeStart: 0,
//     direction: 'left'
//   });
//   $(".AnnouncementBar .AnnouncementBar__Wrapper").css("opacity", "1");
// }, 1000);
  const appHeight = () => {
    const doc = document.body
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  window.addEventListener('resize', appHeight)
  appHeight()

  // Start - Header mobile close menu
  $('#shopify-section-sidebar-menu .Drawer__Close').click(function() {
    $('html').removeClass('no-scroll');
    $('.PageOverlay').removeClass('is-visible');
    $('section#sidebar-menu').attr('aria-hidden','true');
  })
  // End - Header mobile close menu  
})

$(document).ready(function() {
  $('.custom-filtered-products-container .ColorSwatch__Radio').change(function(e) {
    var customProductCard = e.target.closest('.product-card-wrapper');
    var customVariantUrl = e.target.getAttribute('data-variant-url');
    var customMediaEffect = customProductCard.querySelector('.card__media');
    var parentOfImage = customProductCard.querySelector('.media');
    customMediaEffect.classList.add('Image--lazyLoading');

    customProductCard.querySelectorAll('.full-unstyled-link').forEach(link => {
      link.setAttribute('href', customVariantUrl);
    })
    customProductCard.querySelectorAll('.card__heading > a').forEach(link => {
      link.setAttribute('href', customVariantUrl);
    })
    var originalImageElement = customProductCard.querySelector('.motion-reduce');
    if (e.target.hasAttribute('data-image-url') && e.target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {

      parentOfImage.classList.add('changing-image');
      var newImageElement = document.createElement('img');
      newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad motion-reduce';
      newImageElement.setAttribute('data-image-id', e.target.getAttribute('data-image-id'));
      newImageElement.setAttribute('data-src', e.target.getAttribute('data-image-url'));
      newImageElement.setAttribute('data-widths', e.target.getAttribute('data-image-widths'));
      newImageElement.setAttribute('data-sizes', 'auto');
      // Replace the original node
      // if (window.theme.productImageSize === 'natural') {
      //   originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
      // }

      // originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
      setTimeout(() => {
        originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
        customMediaEffect.classList.remove('Image--lazyLoading');
        parentOfImage.classList.remove('changing-image');
      }, 350);

    }
  });
});


// FAQ COLLECTION
// jQuery(function($){
//     $( document ).ready(function(){
//         $('.faq-toggle .toggle-title').click(function(){
//             $(this).parent().toggleClass('opened');
//             $(this).next().slideToggle();
            
//         });
//     });
// });